import { useNavigate } from 'react-router-dom';

export default function OrderDetailHeader() {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="flex justify-between items-center px-3 py-2.5 h-[50px]">
      <div className="w-[30px] h-[30px] flex items-center justify-center">
        <button onClick={handleClose} className="flex items-center justify-center">
          <img src="/icons/close.svg" alt="홈으로 이동" width={30} height={30} />
        </button>
      </div>
      <h1 className="text-lg font-semibold text-[#1F1F1F]">주문 상세</h1>
      <div className="w-[30px] h-[30px]"></div>
    </div>
  );
}
